import { render, staticRenderFns } from "./ShippingListComponent.vue?vue&type=template&id=46f86eaa&"
import script from "./ShippingListComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports